import logEvent, { navigateAfterTracking } from "../tracking/amplitude/log-event"
import { getSlideshowViewEventOptions } from "../tracking/amplitude/log-slideshow-events"
import { isMobile } from "../utils/breakpoints"
import { goToSlide, hideMobileNavigation } from "./player-navigation"
import store from "./player-store"
import { isInfographic, isEmbed, isPresentation } from "./presentation-types"
import { handleShareToggleOpen } from "./share"
import { player } from "./selectors"
import { isPlayerInFullscreen } from "./player-fullscreen-util"
import { getFlagValue, getTestValue } from "../utils/ab_tests"

const nextSlideshowContainer = $("#new-player .next-container")
const nextSlideshowCancel = $("#new-player .j-next-cancel")
const nextSlideshowTimer = $("#new-player .j-timer-count")
const nextButton = $("#new-player .next-slideshow-responsive")
const nextButtonCta = nextButton.find(".next-slideshow-cta")
const embedLastScreen = $("#new-player #lastScreen")
const embedLastScreenOverlay = embedLastScreen.find(".j-last-screen-overlay")
const embedLastScreenEmailButton = embedLastScreen.find(".j-email-cta")
const embedLastScreenShareButton = embedLastScreen.find(".j-share-cta")
const embedLastScreenReplayButton = embedLastScreen.find(".j-last-screen-replay")
const embedLastScreenCloseButton = embedLastScreen.find(".j-lastscreen-close")
const recommendationsEORContainer = $("#new-player .recommendations-container")
const recommendationsCta = recommendationsEORContainer.find(".recommendation-cta")

let countdownInterval = null
let isEORTestVariant = false

const EOR_VIEWS = {
  EMBED_LASTSCREEN: "embed_lastScreen",
  NEXT_BUTTON: "next_button", // AB test (control mobile)
  NEXT_SLIDESHOW: "next_slideshow", // AB test (control desktop)
  RECOMMENDATIONS_SCREEN: "recommendations_screen", // AB test (variant)
}

const goToNextSlideshow = (nextSlideshow) => {
  const redirectUrl = window.location.origin + nextSlideshow.url + "?next_slideshow=" + nextSlideshow.id

  navigateAfterTracking("end_of_reading_autonext_init", null, redirectUrl)
}

const showNextSlideshowScreen = () => {
  logEvent("end_of_reading_autonext", getSlideshowViewEventOptions())
  const nextSlideshow = {
    id: nextSlideshowContainer.data("next-slideshare-id") || 0,
    thumb: nextSlideshowContainer.data("next-slideshare-thumb") || "",
    title: nextSlideshowContainer.data("next-slideshare-title") || "",
    url: nextSlideshowContainer.data("next-slideshare-url") || "#",
  }
  let remainingSeconds = 2
  nextSlideshowTimer.text(remainingSeconds + 1)

  const countDown = () => {
    if (remainingSeconds === 0) {
      clearInterval(countdownInterval)
      goToNextSlideshow(nextSlideshow)
    }

    if (remainingSeconds >= 0) {
      nextSlideshowTimer.text(remainingSeconds)
      remainingSeconds--
    }
  }
  countdownInterval = setInterval(countDown, 1000)

  nextSlideshowContainer.addClass("active")
}

const toggleNextSlideshowScreen = (shouldShow) => {
  if (shouldShow) {
    showNextSlideshowScreen()
  } else {
    clearInterval(countdownInterval)
    store.endDisplay.isActive = false
    nextSlideshowContainer.removeClass("active")
  }
}

const toggleNextButton = (shouldShow) => {
  if (shouldShow) {
    logEvent("end_of_reading_next_slideshow", getSlideshowViewEventOptions())
    nextButton.addClass("active")
  } else {
    store.endDisplay.isActive = false
    nextButton.removeClass("active")
  }
}

const toggleEmbedLastScreen = (shouldShow) => {
  if (shouldShow) {
    embedLastScreen.find("img.j-thumbnail").trigger("loadThumb")
    embedLastScreen.addClass("lastScreenContainer")
    populateEmbedSizes()
    embedLastScreen.css({ display: "flex" })
  } else {
    store.endDisplay.isActive = false
    embedLastScreen.css({ display: "none" })
  }
}

const populateEmbedSizes = () => {
  let embedSizesPicker = embedLastScreen.find(".j-embed-size-picker")
  $.each(store.embedPlayer.embedSizes.presets, function (key, value) {
    let displayWidth = value.size.width + 4
    let displayHeight = value.size.height + 2

    let option = $("<option/>")
      .val(key)
      .text(displayWidth + "x" + displayHeight)
    embedSizesPicker.append(option)
  })
  embedSizesPicker.val(store.embedPlayer.embedSizes.config.defaultPreset).change()
}

const hideStageDownloadCTA = () => {
  $(".stage-download-cta").hide()
}

const showStageDownloadCTA = () => {
  $(".stage-download-cta").show()
}

const initEndOfReadingTestVariant = async () => {
  if (!isPresentation()) {
    return false
  }

  const isFeatureFlagActive = await getFlagValue("end_of_reading_recommendations")
  if (!isFeatureFlagActive) {
    return false
  }

  const testVariant = await getTestValue("end_of_reading") // only assign test for presentations
  isEORTestVariant = testVariant === "recommendations"
}

const toggleRecommendationsEORScreen = (shouldShow) => {
  if (shouldShow) {
    recommendationsEORContainer?.addClass("active")
    logEvent("end_of_reading_recommendations", getSlideshowViewEventOptions())
  } else {
    recommendationsEORContainer?.removeClass("active")
  }
}

const getDisplayType = () => {
  if (isEmbed()) {
    return EOR_VIEWS.EMBED_LASTSCREEN
  }
  if (isEORTestVariant) {
    return EOR_VIEWS.RECOMMENDATIONS_SCREEN
  }
  return isMobile() ? EOR_VIEWS.NEXT_BUTTON : EOR_VIEWS.NEXT_SLIDESHOW
}

const toggleDisplay = (type, shouldShow) => {
  switch (type) {
    case EOR_VIEWS.EMBED_LASTSCREEN: // embed player last screen
      toggleEmbedLastScreen(shouldShow)
      break
    case EOR_VIEWS.NEXT_BUTTON: // mobile
      toggleNextButton(shouldShow)
      break
    case EOR_VIEWS.NEXT_SLIDESHOW: // desktop
      toggleNextSlideshowScreen(shouldShow)
      break
    case EOR_VIEWS.RECOMMENDATIONS_SCREEN:
      toggleRecommendationsEORScreen(shouldShow)
      break
    default:
      break
  }
}

export const showEndDisplay = () => {
  const shouldBlurReader = player.attr("data-shouldblurreader")
  const isUploadPreview = $("body").hasClass("upload-preview")
  if (isUploadPreview || isInfographic() || store.isLoading) {
    return
  }
  store.endDisplay.isActive = true
  hideStageDownloadCTA()
  hideMobileNavigation()
  /**
   * Do not show next slideshow when view restriction is on
   */
  if (!shouldBlurReader) {
    const displayType = getDisplayType()
    toggleDisplay(displayType, true)
  }
}

export const hideEndDisplay = () => {
  if (isInfographic() || store.isLoading) {
    return
  }

  clearInterval(countdownInterval)
  store.endDisplay.isActive = false

  if (!isPlayerInFullscreen()) {
    showStageDownloadCTA()
  }
  const displayType = getDisplayType()
  toggleDisplay(displayType, false)
}

export const isOverlayDisplay = () => getDisplayType() !== EOR_VIEWS.NEXT_BUTTON

export const isEndOfReadingDisplay = () => !!store.endDisplay.isActive

const addToStore = (config) => {
  store.endDisplay = {
    isActive: false,
  }

  store.embedPlayer = {
    embedSizes: config.embed_sizes,
    embedCode: config.embed_code,
    wpCode: config.wp_code,
  }
}

const initializeEmbedLastScreen = () => {
  embedLastScreen.find("img.j-thumbnail").lazyload({
    effect: "fadeIn",
    event: "loadThumb",
  })

  embedLastScreenOverlay.on("click", () => {
    toggleEmbedLastScreen(false)
  })

  embedLastScreenCloseButton.on("click", () => {
    toggleEmbedLastScreen(false)
  })

  embedLastScreenEmailButton.on("click", handleShareToggleOpen)

  embedLastScreenShareButton.on("click", handleShareToggleOpen)

  embedLastScreenReplayButton.on("click", () => {
    toggleEmbedLastScreen(false)
    goToSlide(0)
  })
}

export const initializeEndDisplay = (config) => {
  addToStore(config)

  initEndOfReadingTestVariant()

  initializeEmbedLastScreen()

  nextSlideshowCancel.on("click", function () {
    toggleNextSlideshowScreen(false)
  })

  nextButtonCta.on("click", (e) => navigateAfterTracking("end_of_reading_next_slideshow_clicked", e))

  recommendationsCta.on("click", (e) => navigateAfterTracking("end_of_reading_recommendation_clicked", e))
}
